import { numerify } from '@/filters'
import BillProgress from '@Bill/sections/BillProgress'
import { currencyUnitMap } from '@/constants/currency'
import { getCopyWithContentTableColumn } from '@/utils/common/tableColumn'

export default {
  data () {
    return {
      subUsageDialogColumns: [
        {
          field: 'spec',
          title: this.$t('bill.ri_sub_usage_spec'),
          showOverflow: 'ellipsis',
          minWidth: 160,
          formatter: ({ row }) => row.spec || '-',
        },
        {
          field: 'usage_hours',
          title: this.$t('bill.ri_matched_hours'),
          minWidth: 100,
          formatter: ({ row }) => row.usage_hours != null ? this.formatUsageHours(row.usage_hours) : '-',
        },
        {
          field: 'usage_factor',
          title: this.$t('bill.ri_usage_factor'),
          minWidth: 90,
          formatter: ({ row }) => row.usage_factor != null ? row.usage_factor : '-',
        },
      ],
    }
  },
  computed: {
    allRiCoverageColumns () {
      return [
        {
          field: 'spec',
          title: this.$t('bill.ri_spec'),
          showOverflow: 'ellipsis',
          minWidth: 120,
          slots: {
            default: ({ row }) => {
              if (!row.spec) return '-'
              return [
                <a onClick={() => this.showSpecDetail(row)}>{ row.spec }</a>,
              ]
            },
          },
        },
        {
          field: 'origin_res_type',
          title: this.$t('bill.ri.origin_res_type'),
          showOverflow: 'ellipsis',
          minWidth: 100,
          formatter: ({ row }) => row.origin_res_type || '-',
        },
        getCopyWithContentTableColumn({
          field: 'external_id',
          title: this.$t('bill.external_id'),
        }),
        {
          field: 'sku',
          title: this.$t('bill.ri_category'),
          showOverflow: 'ellipsis',
          minWidth: 100,
          formatter: ({ row }) => row.sku || '-',
        },
        {
          field: 'os',
          title: this.$t('bill.ri_coverage_os'),
          showOverflow: 'ellipsis',
          minWidth: 100,
          formatter: ({ row }) => row.os || '-',
        },
        {
          field: 'region',
          title: this.$t('bill.text_83'),
          showOverflow: 'ellipsis',
          minWidth: 100,
          formatter: ({ row }) => row.region || '-',
        },
        {
          field: 'amount',
          title: this.$t('bill.ri_coverage_cost'),
          showOverflow: 'ellipsis',
          minWidth: 100,
          formatter: ({ row }) => {
            const money = numerify(row.amount, '0,0.00')
            const currencySign = row.currency === 'CNY' ? currencyUnitMap.CNY.sign : currencyUnitMap.USD.sign
            return `${currencySign} ${money}` || '-'
          },
        },
        {
          field: 'usage_hours',
          title: this.$t('bill.ri_usage_hours'),
          showOverflow: 'ellipsis',
          minWidth: 100,
          formatter: ({ row }) => {
            return row.usage_hours != null ? this.formatUsageHours(row.usage_hours) : '-'
          },
        },
        {
          field: 'quantity',
          title: this.$t('bill.ri_quantity'),
          showOverflow: 'ellipsis',
          minWidth: 80,
          formatter: ({ row }) => {
            return row.quantity != null ? row.quantity : '-'
          },
        },
        {
          field: 'usage_factor',
          title: this.$t('bill.ri_usage_factor'),
          showOverflow: 'ellipsis',
          minWidth: 100,
          formatter: ({ row }) => {
            return row.usage_factor != null ? row.usage_factor : '-'
          },
        },
        {
          field: 'coverage',
          title: this.$t('bill.ri_coverage_percentage'),
          showOverflow: 'ellipsis',
          minWidth: 120,
          slots: {
            default: ({ row }) => {
              if (row.coverage == null) return '-'
              const percentage = row.coverage * 100
              return [
                <BillProgress percentage={ percentage } colors={ ['rgb(245, 34, 45', 'rgb(250, 173, 20)', '#52c41a'] } ranges={ [60, 90] }></BillProgress>,
                <span>{ percentage.toFixed(2) }%</span>,
              ]
            },
          },
        },
        {
          field: 'utilization',
          title: this.$t('bill.ri_usage_title'),
          showOverflow: 'ellipsis',
          minWidth: 120,
          slots: {
            default: ({ row }) => {
              if (row.utilization == null) return '-'
              const percentage = row.utilization * 100
              return [
                <BillProgress percentage={ percentage } colors={ ['rgb(245, 34, 45', 'rgb(250, 173, 20)', '#52c41a'] } ranges={ [60, 90] }></BillProgress>,
                <span>{ percentage.toFixed(2) }%</span>,
              ]
            },
          },
        },
        {
          field: 'sub_usage',
          title: this.$t('bill.ri_sub_usage'),
          showOverflow: 'ellipsis',
          minWidth: 100,
          slots: {
            default: ({ row }) => {
              const list = this.parseSubUsage(row.sub_usage)
              if (!list.length) return '-'
              return [
                <a onClick={() => this.showSubUsageDialog(list)}>{this.$t('bill.ri_sub_usage_view', [list.length])}</a>,
              ]
            },
          },
        },
      ]
    },
    riCoverageColumns () {
      return this.filterRiCoverageColumns(this.allRiCoverageColumns)
    },
    riCoverageDetailColumns () {
      const columns = this.allRiCoverageColumns.filter(col => col.field !== 'spec')
      return this.filterRiCoverageColumns(columns)
    },
  },
  methods: {
    filterRiCoverageColumns (columns) {
      const hidden = this.riCoverageHiddenFields || []
      if (!hidden.length) return columns
      return columns.filter(col => col.field && !hidden.includes(col.field))
    },
    showSpecDetail (row) {
      if (!row.spec) return
      this.sidePageTriggerHandle(this, 'RiCoverageSpecSidePage', {
        id: row.spec,
        resource: () => ({
          data: {
            spec: row.spec,
            name: row.spec,
          },
        }),
      }, {
        cloudaccountId: this.cloudaccountId,
        dateParam: this.dateParam,
        tab: 'ri-coverage-spec-detail',
      })
    },
    parseSubUsage (subUsage) {
      if (!subUsage) return []
      if (typeof subUsage === 'string') {
        try {
          const parsed = JSON.parse(subUsage)
          return Array.isArray(parsed) ? parsed : []
        } catch (e) {
          return []
        }
      }
      return Array.isArray(subUsage) ? subUsage : []
    },
    showSubUsageDialog (data) {
      this.createDialog('CommonDialog', {
        hiddenCancel: true,
        header: this.$t('bill.ri_sub_usage'),
        body: () => [
          <dialog-table
            vxeGridProps={{ showOverflow: 'title' }}
            data={data}
            columns={this.subUsageDialogColumns}
          />,
        ],
      })
    },
    formatUsageHours (val) {
      const n = Number(val)
      if (Number.isNaN(n)) return 0
      if (Number.isInteger(n)) return n
      return parseFloat(n.toFixed(2))
    },
  },
}
